import AnalyticsOrganisationItemModelBase from '../_generated/modelBases/analytics-organisation-item-model-base';

export default class AnalyticsOrganisationItemModel extends AnalyticsOrganisationItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
